export interface User {
  _id?: string;
  email?: string;
  name?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  roles?: Roles;
  token?: string;
}

export interface GuestUser {
  _id?: string;
  email?: string;
  name?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  role?: Roles;
}

export enum Roles {
  user = 'user',
  guest = 'guest'
}
